import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import { useEffect, useState } from 'react'

const CustomDateTimeComponent = ({
  label = '',
  value,
  onChange = (v) => {},
  helperText = '',
  error = false,
  required = false,
  disabled = false,
  minDate = null,
  maxDate,
}) => {
  const [internalValue, setInternalValue] = useState(value)

  const handleChange = (newValue) => {
    setInternalValue(newValue)
    onChange(newValue)
  }

  useEffect(() => {
    if (value) {
      setInternalValue(dayjs(value))
    }
  }, [value])

  return (
    <MobileDateTimePicker
      label={`${label}${required ? ' *' : ''}`}
      value={internalValue}
      onChange={handleChange}
      disabled={disabled}
      slotProps={{
        clearable: true,
        textField: {
          helperText: helperText,
          error: error,
          fullWidth: true,
        },
      }}
      minDate={minDate}
      maxDate={maxDate}
      sx={{ width: '100%' }}
    />
  )
}

export default CustomDateTimeComponent
